exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#prfile-container form {\n  background-color: white;\n  box-shadow: 0px 0px 10px 1px #dbd9d8;\n  margin: 3rem 0;\n  padding: 5%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/perfil/perfil.component.scss
// module id = ../../../../../src/app/components/perfil/perfil.component.scss
// module chunks = main